/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-throw-literal */
// Estado de los reducer de login
import { companiesId, salesRoles } from 'Utils/constants'
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_COMPANY,
  LOGIN_SUCCESS_COMPANY,
  LOGIN_ERROR_COMPANY,
  COMPANY_ERROR_STORE,
  IS_CUSTOMER,
  OPEN_LOGIN_MODAL,
  CLEAR_TOKEN,
} from '../types'
import { setCompany } from './companyAction'
import { searchCompanyName } from 'Utils/functions'
import { loginCompany, loginUser } from 'api/core'
// Consumir WS de login
export const authenticateUser = (user, pass, company, userInfo) => {
  const loginUserAction = () => ({ type: LOGIN_USER })
  const loginSuccess = data => ({ type: LOGIN_SUCCESS, payload: data })
  const loginError = estado => ({ type: LOGIN_ERROR, payload: estado })
  const clearTokenUser = () => ({
    type: CLEAR_TOKEN,
  })
  const loginErrorStore = estado => ({
    type: COMPANY_ERROR_STORE,
    payload: estado,
  })
  const authenticateCompany = () => ({ type: LOGIN_COMPANY })
  const loginSuccessCompany = data => ({
    type: LOGIN_SUCCESS_COMPANY,
    payload: data,
  })
  const loginErrorCompany = estado => ({
    type: LOGIN_ERROR_COMPANY,
    payload: estado,
  })
  const isCustomer = payload => ({ type: IS_CUSTOMER, payload })

  return async dispatch => {
    let sw = false
    clearTokenUser()
    dispatch(authenticateCompany())

    try {
      const responseCompany = await loginCompany(company)

      if (responseCompany.data.Data.length === 0) throw 'empresanoexiste'
      if (responseCompany.data.Data[0].CompanyName !== 'Cochez')
        throw 'empresanoexiste'

      dispatch(loginSuccessCompany(responseCompany.data.Data))
      sw = true
    } catch (error) {
      if (error === 'empresanoexiste') {
        dispatch(loginErrorCompany('La empresa no existe, intente de nuevo'))
      }
      return Promise.reject(error) // 👈 devolvemos error para que lo capture el componente
    }

    if (sw) {
      dispatch(loginUserAction())

      try {
        const userCredentials = { Email: user, Password: pass, Tenant: 2 }
        const response = await loginUser(userCredentials)

        if (response.data?.Data?.CustomerInfo?.LoginCode === 404) {
          dispatch(loginError('Este usuario no existe'))
          return Promise.reject('Este usuario no existe')
        }

        if (response.data?.Data?.CustomerInfo?.LoginCode === 401) {
          dispatch(loginError('Credenciales Inválidas'))
          return Promise.reject('Credenciales Inválidas')
        }

        if (response.data?.Status?.Code === 400) {
          dispatch(loginError('Ha ocurrido un error'))
          return Promise.reject('Ha ocurrido un error')
        }

        if (response.data?.Data?.CustomerInfo?.Warehouses === null) {
          dispatch(loginErrorStore(true))
        } else {
          dispatch(loginErrorStore(false))
        }

        if (response.data.Data.CustomerInfo.LoginCode === 200) {
          const hasCustomerRole =
            response.data.Data.AuthenticationInfo.UserRoles.some(
              roleObject => roleObject.RoleName === salesRoles.customer
            )
          dispatch(isCustomer(hasCustomerRole))

          const warehouses = response?.data?.Data?.CustomerInfo?.Warehouses
          if (warehouses?.length) {
            dispatch(loginSuccess(response.data.Data))

            const companies = response.data?.Data?.CustomerInfo?.Companies
            const searchCohez = companies.some(
              company => company.CompanyId === companiesId.cochez
            )

            const defaultCompany = searchCohez
              ? companies.find(
                  company => company.CompanyId === companiesId.cochez
                )
              : companies?.length && companies?.[0]

            const warehouseCompanySelected = warehouses.filter(
              warehouse => warehouse?.CompanyId === defaultCompany?.CompanyId
            )

            const companyInfo = userInfo || defaultCompany
            const warehouseInfo = userInfo || warehouseCompanySelected?.[0]

            const objCompanyWarehouse = {
              CompanyCode: companyInfo?.Code || companyInfo?.CompanyCode,
              CompanyName: companyInfo?.Name || companyInfo?.CompanyName,
              CompanyId: companyInfo?.CompanyId,
              WarehouseCode: warehouseInfo?.WarehouseCode,
              WarehouseId: warehouseInfo?.WarehouseId,
              WarehouseDescription: warehouseInfo?.WarehouseDescription,
              WarehouseAddress: warehouseInfo?.WarehouseAddress,
              WarehouseName: warehouseInfo?.WarehouseName,
              DefaultWarehouse: warehouseInfo?.WarehouseName,
              ProfileImage: companyInfo?.ProfileImage,
            }

            window.localStorage.setItem(
              'company',
              searchCompanyName(objCompanyWarehouse)
            )

            dispatch(setCompany(objCompanyWarehouse))

            return Promise.resolve(response.data.Data)
          }
        }
      } catch (error) {
        return Promise.reject(error)
      }
    }
  }
}

export const openLoginModal = status => ({
  type: OPEN_LOGIN_MODAL,
  payload: status,
})
